import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as angular from "angular";
import * as moment from "moment";
import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";
import {ShopActivity} from "../../models/activity/shopActivity";
import DefectTypeServiceName, {DefectTypeService} from "../defects/defectType.service";
import ToolChangeServiceName, {ToolChangeService} from "../toolChange/toolChange.service";
import UserProfileName, {UserProfile} from "../../models/userProfile";

let requires = [HttpServiceName, DefectTypeServiceName, ToolChangeServiceName, UserProfileName];

export interface LineSheetService {
  getLineSheetActivity(shopId: string, date: moment.Moment): angular.IPromise<ShopActivity>;
  getLineSheetActivityData(shopId: string, date: moment.Moment): angular.IPromise<apsViewModels.ShopActivity>;
  lockHour(command: apsCommands.LockHour): angular.IPromise<any>;
  unlockHour(command: apsCommands.UnlockHour): angular.IPromise<any>;
}

export default angular.module('aps.services.lineSheet', requires)
  .service('lineSheetService',
  function ($q: angular.IQService,
            httpService: HttpService,
            defectTypeService: DefectTypeService,
            userProfile: UserProfile,
            toolChangeService: ToolChangeService): LineSheetService {

    function getLineSheetActivity(shopId: string,
                                  date: moment.Moment): angular.IPromise<ShopActivity> {                                   
      return $q.all([
        httpService.get(Endpoints.LINESHEET, {
          shopId: shopId,
          date: date ? date.format() : null
        }),
        defectTypeService.getDefectTypesAndClassifications(),
        toolChangeService.getToolsAndTypes(),
        userProfile.read()
      ]).then((response) =>
        new ShopActivity(response[0] as apsViewModels.ShopActivity, response[1], response[3], response[2],this.jobs,this.jobProcess, this.eightyHrTools, this.oneSixtyHrTools));
    }

    function getLineSheetActivityData(shopId: string,
                                      date: moment.Moment): angular.IPromise<apsViewModels.ShopActivity> {
      return httpService.get(Endpoints.LINESHEET, {
          shopId: shopId,
          date: date ? date.format() : null
        });
    }

    function lockHour(command) {
      return httpService.post(Endpoints.LINESHEET_LOCK_HOUR, command);
    }

    function unlockHour(command) {
      return httpService.post(Endpoints.LINESHEET_UNLOCK_HOUR, command);
    }

    return {
      getLineSheetActivity: getLineSheetActivity,
      getLineSheetActivityData: getLineSheetActivityData,
      lockHour: lockHour,
      unlockHour: unlockHour
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/lineSheet/lineSheet.service.ts